var map = {
	"./SignPainter-HouseScript.woff": 89,
	"./proximasoft-bold-webfont.woff": 92,
	"./proximasoft-regular-webfont.woff": 96
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font ^\.\/.*\.woff$
// module id = 34
// module chunks = d-game